import React from 'react';
interface WavesProps {
  className?: string;
  fill?: string;
}
export function Waves({
  className = '',
  fill = 'fill-white'
}: WavesProps) {
  return <div className={`absolute left-0 w-full overflow-hidden leading-none ${className}`} data-id="element-96">
      {/* Back wave */}
      <svg className="absolute bottom-0 left-0 block w-[200%] h-[80px] md:h-[150px] wave-animate-slow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2400 120" preserveAspectRatio="none" data-id="element-97">
        <path className={`${fill} opacity-30`} d="M0,60 C300,120 900,0 1200,60 C1500,120 2100,0 2400,60 L2400,120 L0,120 Z" data-id="element-98" />
      </svg>
      {/* Middle wave */}
      <svg className="absolute bottom-0 left-0 block w-[200%] h-[80px] md:h-[150px] wave-animate-normal" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2400 120" preserveAspectRatio="none" data-id="element-99">
        <path className={`${fill} opacity-60`} d="M0,80 C300,20 900,140 1200,80 C1500,20 2100,140 2400,80 L2400,120 L0,120 Z" data-id="element-100" />
      </svg>
      {/* Front wave */}
      <svg className="relative block w-[200%] h-[80px] md:h-[150px] wave-animate-fast" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2400 120" preserveAspectRatio="none" data-id="element-101">
        <path className={`${fill}`} d="M0,100 C300,60 900,140 1200,100 C1500,60 2100,140 2400,100 L2400,120 L0,120 Z" data-id="element-102" />
      </svg>
    </div>;
}